import React, { useEffect, useRef, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import CIcon from '@coreui/icons-react';
import { cilUser } from '@coreui/icons';
import moment from 'moment';
import { useSelector } from 'react-redux';

const ImagePicker = (prop) => {
  const { image, onChange, canEditDA = true } = prop;
  const [selectedImage, setSelectedImage] = useState('');
  const [isError, setIsError] = useState(false);
  const [logoAvatar, setLogoAvatar] = useState();
  const user = useSelector((state) => state.user);

  const [data, setData] = useState({
    name: '',
    fileName: 0,
    userId: '',
    lastUpdatedAt: moment().utc().format(),
    lastUpdatedBy: user.userId,
    createdAt: moment().utc().format(),
    createdBy: user.userId,
  });

  const fileInputRef = useRef(null);
  const dropRef = useRef(null);

  // Sync with prop image when it changes
  useEffect(() => {
    if (image && !logoAvatar) {
      setSelectedImage(image);
      setIsError(false);
    }
  }, [image, logoAvatar]);

  const handleImageChange = (event) => {
    if (!canEditDA) return;
    setData({ ...data, [event.target.name]: event.target.value });
    const file = event.target.files[0];
    if (file) {
      readImage(file);
    }
  };

  const readImage = (file) => {
    setLogoAvatar(file);
    const reader = new FileReader();
    reader.onloadend = () => {
      setSelectedImage(reader.result);
      onChange(file.name);
      setIsError(false);
    };
    reader.readAsDataURL(file);
  };

  const handleIconButtonClick = () => {
    if (!canEditDA) return;
    fileInputRef.current.click();
  };

  const handleError = () => {
    setIsError(true);
  };

  // 🟡 Drag & Drop support
  const handleDragOver = (e) => e.preventDefault();
  const handleDrop = (e) => {
    if (!canEditDA) return;
    e.preventDefault();
    const file = e.dataTransfer.files?.[0];
    if (file) readImage(file);
  };

  // 🟡 Paste image support
  const handlePaste = (e) => {
    if (!canEditDA) return;
    const items = e.clipboardData?.items;
    if (!items) return;
    for (const item of items) {
      if (item.type.indexOf('image') !== -1) {
        const file = item.getAsFile();
        readImage(file);
        break;
      }
    }
  };

  // Attach paste listener
  useEffect(() => {
    const area = dropRef.current;
    area?.addEventListener('paste', handlePaste);
    return () => area?.removeEventListener('paste', handlePaste);
  }, []);

  return (
    <div
      className="w-100 d-flex justify-content-center align-items-center"
      ref={dropRef}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      <div
        className="image-picker-container"
        style={{
          position: 'relative',
          width: 85,
          height: 85,
          borderRadius: '50%',
          overflow: 'hidden',
          border: '2px solid #ccc',
          cursor: 'pointer',
        }}
        onClick={handleIconButtonClick}
      >
        <input
          type="file"
          accept="image/*"
          id="fileAvatar"
          name="fileAvatar"
          onChange={handleImageChange}
          ref={fileInputRef}
          style={{ display: 'none' }}
        />

        {selectedImage && !isError ? (
          <img
            src={selectedImage}
            alt="Selected"
            className="w-100 h-100 object-fit-cover rounded-circle"
            onError={handleError}
          />
        ) : (
          <div
            className="w-100 h-100 d-flex justify-content-center align-items-center"
            style={{ backgroundColor: '#f8f8f8' }}
          >
            <img
              src="Profile-pic.jpg"
              alt="Default"
              className="w-100 h-100 object-fit-cover rounded-circle"
            />
            <CIcon
              icon={cilUser}
              size="xxl"
              style={{
                color: '#a39898',
                position: 'absolute',
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ImagePicker;
